function havePermissionTo(resouceRequest, myPermissions) {

  let havePermission = false;
  
  // Quais perfis podem acessar

  const permissionsResources = resourses[resouceRequest];

  // test if have permission to access to resource
  if (permissionsResources && myPermissions && myPermissions.length && typeof myPermissions === 'object') {
    havePermission = myPermissions.some(permission => {
      return ( permissionsResources.indexOf(permission) >= 0 )
    });
  }

  return havePermission;
}

const resourses = {
  // Pages Resources
  "register": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "main": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "reconcile": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
  ],
  "conciliation-status": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "load": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
  ],
  "load-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Fornecedor",
  ],
  "scheduling": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Fornecedor",
  ],
  "cd-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "cd-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "box-tag": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "price-tag": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "import-chart": [
    "NPFornec_Youcom_Usuario",
  ],
  "edit-declaration-details" : [
    "NPFornec_Renner_Admin"
  ],
  "declaration-details" : [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "edit-sustainability-status": [
    "NPFornec_Renner_Admin"
  ],
  "edit-norm-details": [
    "NPFornec_Renner_Admin"
  ],
  "declaration-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "norm-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "norm-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "sustainability-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "scheduling-report": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "pre-scheduling-report": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Renner_Logistica",
  ],
  "scheduling-report-change-company": [
    "NPFornec_Renner_Admin",
  ],
  "provider-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "edit-provider-list": [
    "NPFornec_Renner_Admin",
  ],
  "sustainability": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "sustainability-add-file": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Fornecedor",
  ],
  "producer-declaration": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "sustainability-status": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "provider-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "pre-scheduling": [
    "NPFornec_Renner_Admin",
  ],
  "pre-scheduling-list": [
    "NPFornec_Renner_Admin",
  ],
  "pre-scheduling-details": [
    "NPFornec_Renner_Admin",
  ],
  "subcontractor-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "subcontractor-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "order-options": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "subcontractor-invoice": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "cancel-conciliation": [
    "NPFornec_Renner_Admin",
    "NPFornec_Camicado_Usuario",
  ],
  "aceite-pedido": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
  ],
  "resto-sobra": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
  ],
  // Outher Resources
  "btn-po-report": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "btn-po-report-admin": [
    "NPFornec_Renner_Admin",
  ],
  "btn-conciliate-conditional": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "filter-provider": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario",
    "NPFornec_Youcom_Usuario",
    "NPFornec_Camicado_Usuario",
  ],
  "filter-company": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Fornecedor",
    "NPFornec_Renner_Logistica"
  ],
  "conciliation-report": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "conciliation-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],  
  "order-sample-list": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "order-sample-details": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "box-tag-admin-print": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "admin_alter_load_permissions": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
  ],
  "idgf": [
    "NPFornec_Renner_Fornecedor",
  ],
  "links-fornecedor": [
    "NPFornec_Renner_Fornecedor"
  ],
  "origin-certificate": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario"
  ],
  "origin-certificate-upload": [
    "NPFornec_Renner_Admin",
    "NPFornec_Renner_Logistica",
    "NPFornec_Renner_Usuario"
  ]
};

export default havePermissionTo;
